import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-mp-black py-20 md:py-28" data-id="element-100" data-mp="m3wyyuuc0zj3">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-40" aria-hidden="true" data-id="element-101" data-mp="h6dlvy9dessq" />
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(ellipse at 50% 20%, rgba(8,93,168,0.3), transparent 65%)'
    }} aria-hidden="true" data-id="element-102" data-mp="vv9sdqvs3xr8" />
      <Container className="relative z-10 text-center" data-id="element-103" data-mp="14whnk0300ih3">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} data-id="element-104" data-mp="14t3n4xdwajca">
          <SectionTag tone="white" data-id="element-105" data-mp="2h37xky5u4kz3">La próxima clase llegará igualmente.</SectionTag>
          <h2 className="mx-auto mt-5 max-w-[820px] font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-106" data-mp="2m3416wameae4">
            La pregunta es si volverás a improvisarla.
          </h2>

          <p className="mx-auto mt-6 max-w-[600px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-107" data-mp="2v428bngcuy0x">
            Necesitas saber qué trabajar, por qué trabajarlo, cómo corregirlo y qué viene después. Eso es Maestro
            en Pista.
          </p>

          <p className="mx-auto mt-5 max-w-[600px] text-xs uppercase tracking-wide text-mp-gray/70 md:text-sm" data-id="element-108" data-mp="34u3ug9p5e6d7">
            5 tomos · 250+ páginas · 5 bonos · Garantía 14 días · El precio de un menú del día.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: easeOut
      }} src={FULL_MOCKUP_URL} alt="Sistema completo Maestro en Pista" width={600} height={600} loading="lazy" className="mx-auto mt-12 w-full max-w-[380px]" data-id="element-109" data-mp="3islg81vht8sh" />

        <div className="mx-auto mt-10 grid max-w-[760px] grid-cols-1 gap-5 text-left sm:grid-cols-2" data-id="element-110" data-mp="1np5b5i9s3oy3">
          <div className="rounded-2xl border border-mp-border bg-mp-dark/80 p-6" data-id="element-111" data-mp="22d9saht6nser">
            <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-112" data-mp="1xeou0nxhrisy">Maestro en Pista</p>
            <p className="mt-3 font-heading text-4xl text-mp-white" data-id="element-113" data-mp="2be80lcanmm35">16,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-114" data-mp="27do1w4afnaew">Pago único</p>
            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" className="mt-5 w-full" showArrow data-id="element-115" data-mp="h0qb3jqovf5h">
              Versión base
            </CTAButton>
          </div>

          <div className="relative rounded-2xl border-2 border-mp-lime bg-mp-dark/80 p-6 shadow-glow-lime" data-id="element-116" data-mp="2vye3nk22fuy">
            <span className="absolute -top-3 left-6 rounded-full bg-mp-lime px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-wide text-mp-black" data-id="element-117" data-mp="6xbevj8ajsv0">
              Recomendado
            </span>
            <p className="mt-2 font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-118" data-mp="3ua409e63aj2u">
              Maestro en Pista + Kit de Ejecución
            </p>
            <p className="mt-3 font-heading text-4xl text-mp-lime" data-id="element-119" data-mp="3ffhfohvurqsa">21,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-120" data-mp="3ke120jecz4l6">
              Solo 5 € más que la versión base
            </p>
            <CTAButton href={KIT_CHECKOUT_URL} className="mt-5 w-full" showArrow data-id="element-121" data-mp="3bbhydx2r0nxv">
              Quiero todo incluido
            </CTAButton>
          </div>
        </div>

        <p className="mt-6 text-center text-xs text-mp-gray sm:text-sm" data-id="element-122" data-mp="14j8xdgmo7y6y">
          💳 Pago único &nbsp;·&nbsp; ⚡ Acceso inmediato &nbsp;·&nbsp; 🛡️ Garantía 14 días &nbsp;·&nbsp; Sin
          suscripción
        </p>
      </Container>
    </section>;
}